export default {
  SET_MEETINGS(state, meetings) {
    state.meetings = [...meetings];
  },

  SET_LOADING_MEETINGS(state, isLoading) {
    state.loadingMeetings = isLoading;
  },

  SET_APPOINTMENT(state, appointment) {
    state.currentAppointment = appointment;
  },

  CANCEL_APPOINTMENT(state, appointment) {
    state.appointmentToBeCancelled = appointment;
  },
};
